<script>
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import Username from "../../components/Username.svelte";
  import LastResult from "../../components/ranking/last-result/LastResult.svelte";
  import LastResultF1StartTimer from "../../components/ranking/last-result/LastResultF1StartTimer.svelte";
  import OneResult from "../../components/ranking/one-result/OneResult.svelte";
  import OneResultF1StartTimer from "../../components/ranking/one-result/OneResultF1StartTimer.svelte";
  import { SyncLoader } from "svelte-loading-spinners";
  import Icon from "svelte-awesome";
  import { faSyncAlt, faChevronUp, faHome } from "@fortawesome/free-solid-svg-icons";
  import swal from "sweetalert";
  import GameNameEnums from "../../enums/GameName";
  import DifficultyEnums from "../../enums/Difficulty";
  import GetNotyfInstance from "../../services/ServiceNotyf";
  import GetRequestApiInstance from "../../services/ServiceRequestApi";
  // instances services
  const notyfInstance = GetNotyfInstance();
  const requestApiInstance = GetRequestApiInstance();
  // paramètres
  export let params = {};
  let paramGameName = params.gameName;
  let paramDifficulty = params.difficulty;
  // variables
  let inputUsername;
  let isSaved = false;
  let result = {
      game_name: "",
      difficulty: "",
      score: 0,
      average_time_reaction: 0,
      best_time_reaction: 0
  };
  let isSameDifficulty = false;
  let results;
  let resultUsernameId;
  
  getResults();
  getResultUsernameId();

  onMount(() => {
    if(localStorage.getItem("lastBase64") == params.result) {
      isSaved = true;
    }
  });

  async function getResultUsernameId() {
    if(localStorage.getItem("username")) {
      await requestApiInstance.get(`username/${paramGameName}/${paramDifficulty}/${localStorage.getItem("username")}`)
      .then(res => {
        if(res.length)
          resultUsernameId = res[0]._id;
      });
    }
  }
  
  // S'il existe une information dans params.result (dans l'url), décrypter les informations et les ajouter dans la varialbe paramResult
  if(params.result) {
    let urlDecrypt = atob(params.result);
    var paramResult = new URLSearchParams(urlDecrypt);
    for (let key of paramResult.keys()) {
      result[key] = paramResult.get(key);
    }
  }

  if(paramDifficulty == result.difficulty) {
    isSameDifficulty = true;
  }
  
  // Récupérer les resultats depuis l'api
  async function getResults() {
    await requestApiInstance.get(`results/${paramGameName}/${paramDifficulty}`)
    .then(res => {
      results = res;
    });
  }

  // Fonction qui permet d'ajouter un résultat dans la base de données
  async function createResult() {
    if(result) {
      getResultUsernameId();
      let username = localStorage.getItem("username"); // Récupérer le username qui se trouve dans le localStorage

      // API chercher si un resultat existe pour ce username et pour cette difficulté
      let responseUsername = [];
      await requestApiInstance.get(`username/${paramGameName}/${paramDifficulty}/${username}`)
      .then(res => {
        responseUsername = res;
      });
      let existingUsername = responseUsername.length ? true : false;
      
      if(username) { // Si le username (dans le localStorage) existe (n'est pas vide)
        if(existingUsername) { // S'il existe un résultat de la requête précédente
          let existingUsernameScore = responseUsername[0].score;
          let existingUsernameTimeReaction = responseUsername[0].time_reaction;
          
          if(result.score <= existingUsernameScore || result.time_reaction >= existingUsernameTimeReaction) { // Si le score du resultat actuel est inférieur ou égal au score existant pour le même username
            showPopUpExistingUsername(username);
          } else { // Sinon, si le score du resultat actuel est strictement supérieur
            showPopUpBestResult(username)
            .then(async (willDelete) => {
              if(willDelete) {
                if(result) {
                  await requestApiInstance.delete(`result`, { '_id': responseUsername[0]._id })
                  .then(async (res) => {
                    let bodyPostResult = getBody(username);
                    await requestApiInstance.post(`result`, bodyPostResult)
                    .then(res => {
                      isSaved = true;
                      getResults();
                      notyfInstance.success("Résultat remplacé avec succès");
                      // localStorage.setItem('lastBase64', params.result);
                    });
                  })
                  .catch(err => {
                    notyfInstance.error("Erreur lors de la suppression de l'ancien résultat");
                    console.log(err);
                  });
                }
              }
            });
          }
        } else {
          let bodyPostResult = getBody(username);
          await requestApiInstance.post(`result`, bodyPostResult)
          .then(res => {
            isSaved = true;
            getResults();
            notyfInstance.success('Résultat sauvegardé avec succès');
            // localStorage.setItem('lastBase64', params.result);
          })
          .catch(err => {
            notyfInstance.error("Erreur lors de la création du nouveau résultat");
            console.log(err);
          });
        }
      } else {
        notyfInstance.warning("Saisir un pseudo");
        inputUsername.focus();
      }
    }
  }

  function getBody(username) {
    let body = {};
    if(paramGameName == "f1-start-timer") {
      body = {
        username: username,
        game_name: result.game_name,
        difficulty: result.difficulty,
        time_reaction: parseFloat(result.time_reaction),
      };
    } else {
      body = {
        username: username,
        game_name: result.game_name,
        difficulty: result.difficulty,
        score: parseFloat(result.score),
        average_time_reaction: parseFloat(result.average_time_reaction),
        best_time_reaction: parseFloat(result.best_time_reaction)
      };
    }
    return body;
  }
  function showPopUpExistingUsername(username) {
    swal({
      title: 'Un résultat existe pour ce pseudo',
      text: `Êtes-vous ` + username + ` ?
      Si ce n\'est pas le cas, changer de pseudo`,
      icon: "warning",
      buttons: true,
      buttons: ["Fermer", "Changer de pseudo"],
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        inputUsername.focus();
        notyfInstance.warning("Changer de pseudo");
      }
    });
  }
  function showPopUpBestResult(username) {
    return swal({
      title: 'Un résultat existe pour ce pseudo',
      text:  `Êtes-vous ` + username + ` ?
      Si oui, remplacer le résultat existant`,
      icon: "warning",
      buttons: true,
      buttons: ["Fermer", "Remplacer le résultat existant"],
      dangerMode: true,
    });
  }
  function retry() {
    push('/' + paramGameName + '/' + paramDifficulty);
  }

  function home() {
    push('/');
  }
</script>

<style>
    .container-header {
        height: 15vh!important;
    }
    .content {
        height: 85vh!important;
    }
    .retry, .home {
        @apply m-auto bg-transparent border-none;
    }
</style>

<div class="container-global">
    <div class="container-header">
        <div class="flex flex-row items-center justify-center py-0 px-2">
          <div class="div-home">
            <button class="home" on:click={home}>
              <Icon data={faHome} scale="1.4" />
            </button>
          </div>
          <div class="title-header">
            <div>Classement</div>
            <div class="text-lg">
              {GameNameEnums.label(paramGameName)} - {DifficultyEnums.label(paramDifficulty)} ({#if results}{#await results}-{:then results}{results.length}{/await}{:else}-{/if} resultats)
            </div>
          </div>
          <div class="div-retry">
            <button class="retry" on:click={retry}>
              <Icon data={faSyncAlt} scale="1.2" />
            </button>
          </div>
        </div>
    </div>
    <div class="content">
        {#if params.result}
            {#if paramGameName == "f1-start-timer"}
                <LastResultF1StartTimer timeReaction={result.time_reaction} />
            {:else}
                <LastResult score={result.score} averageTimeReaction={result.average_time_reaction} bestTimeReaction={result.best_time_reaction} />
            {/if}
        {/if}
        {#if (result.score > 0 && !isSaved && isSameDifficulty) || (result.time_reaction > 0 && !isSaved && isSameDifficulty)}
            <Username bind:inputUsername={inputUsername} />
            <div class="flex justify-center items-center mt-1">
                <button class="flex items-center button-reactivity-bg my-2" on:click={createResult}>
                    Sauvegarder
                </button>
            </div>
        {/if}
        {#if results}
            {#await results}
                <div class="mt-5 div-loader">
                    <SyncLoader size="60" color="#bdbca2" unit="px"></SyncLoader>
                </div>
            {:then then_results}
                <div class="pt-2 bg-beige-light">
                    {#each then_results as oneResult, i}
                        {#if paramGameName == "f1-start-timer"}
                            <OneResultF1StartTimer oneResult={oneResult} counter={i} resultUsernameId={resultUsernameId} gameNameColor={GameNameEnums.color(paramGameName)} />
                        {:else}
                            <OneResult oneResult={oneResult} counter={i} resultUsernameId={resultUsernameId} gameNameColor={GameNameEnums.color(paramGameName)} />
                        {/if}
                    {/each}
                </div>
            {:catch error}
                <div class="mt-5 div-loader">
                    <SyncLoader size="60" color="#bdbca2" unit="px"></SyncLoader>
                </div>
                <div>
                    Erreur au chargement des données : {error}
                </div>
            {/await}
        {:else}
            <div class="mt-5 div-loader">
                <SyncLoader size="60" color="#bdbca2" unit="px"></SyncLoader>
            </div>
        {/if}
    </div>
</div>